import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MsalModule, MsalInterceptor, MsalRedirectComponent } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './header/header.component';
import { NavigationComponent } from './navigation/navigation.component';
import { environment } from '../environments/environment';
import { FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { NotificationService } from './utils/notification.service';
import { SimpleLayoutComponent } from './layouts/simple-layout/simple-layout.component';
import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';
import { LandingModule } from './landing/landing.module';
import { SharedModule } from './shared/shared.module';
import { CookieService } from 'ngx-cookie-service';
import { AuthGuard } from './shared/auth.guard';
import { ErrorInterceptor } from './shared/error.interceptor';
import { VersionInterceptor } from './shared/version.interceptor';
import { BrowserCacheLocation, InteractionType, LogLevel, PublicClientApplication } from '@azure/msal-browser';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    NavigationComponent,
    SimpleLayoutComponent,
    FullLayoutComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    MsalModule.forRoot(new PublicClientApplication({
      auth: {
        clientId: environment.clientId,
        authority: `https://login.microsoftonline.com/${environment.tenantId}`,
        redirectUri: environment.redirectUrl,
        postLogoutRedirectUri: environment.redirectUrl
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: isIE
      },
      system: {
        loggerOptions: {
          loggerCallback: (logLevel: LogLevel, message: string) => {
            // do noting
          },
          logLevel: LogLevel.Error,
          piiLoggingEnabled: false
        }
      }
    }), {
      interactionType: InteractionType.Redirect,
      loginFailedRoute: environment.redirectUrl
    }, {
      interactionType: InteractionType.Redirect,
      protectedResourceMap: new Map([
        [`${environment.datalabUrl}*`, [environment.datalabScope]],
        [`${environment.fusUrl}/*`, [environment.fusScope]]
      ])
    }),
    ToastrModule.forRoot(),
    LandingModule,
    SharedModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: VersionInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
      deps: [NotificationService]
    },
    NotificationService,
    CookieService,
    AuthGuard
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
